import API from './api';

const list = (resource) => API.get(`/skills/${resource}/`, {
  params: { include_archived: true, page_size: 500 },
}).then((response) => response.data);

const create = (resource, payload) => API.post(`/skills/${resource}/`, payload)
  .then((response) => response.data);
const update = (resource, uuid, payload) => API.patch(`/skills/${resource}/${uuid}/`, payload, {
  params: { include_archived: true },
})
  .then((response) => response.data);
const retire = (resource, uuid) => API.delete(`/skills/${resource}/${uuid}/`);

export const getManagedSkills = () => list('skills');
export const createManagedSkill = (payload) => create('skills', payload);
export const updateManagedSkill = (uuid, payload) => update('skills', uuid, payload);
export const retireManagedSkill = (uuid) => retire('skills', uuid);

export const getManagedSkillTypes = () => list('skill_types');
export const createManagedSkillType = (payload) => create('skill_types', payload);
export const updateManagedSkillType = (uuid, payload) => update('skill_types', uuid, payload);
export const retireManagedSkillType = (uuid) => retire('skill_types', uuid);

export const getManagedTemplates = () => list('templates');
export const createManagedTemplate = (payload) => create('templates', payload);
export const updateManagedTemplate = (uuid, payload) => update('templates', uuid, payload);
export const retireManagedTemplate = (uuid) => retire('templates', uuid);
